import React from 'react';
import {
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import FormDialog from '../FormDialog';
import { EXCEPTION_ACTION_OPTIONS } from '../../utils/constants';

const ExceptionHandlingDialog = ({
  open,
  onClose,
  onSubmit,
  loading,
  remarks,
  setRemarks,
  action,
  setAction,
  title = "Push to Exception Handling",
}) => {
  if (!open) return null;

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (loading) return false;
    onSubmit();
    return false;
  };

  const disabledSubmit = loading || !remarks.trim();

  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title={title}
      handleSubmit={handleSubmit}
      loading={loading}
      disabledSubmit={disabledSubmit}
      maxWidth="sm"
      showActions={true}
    >
      <form onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2} alignItems="center">
          <Grid item md={4} xs={12}>
            <Typography variant="subtitle1" align="right">
              Action *
            </Typography>
          </Grid>
          <Grid item md={8} xs={12}>
            <FormControl fullWidth size="small" margin="dense" disabled={loading}>
              <Select
                value={action}
                onChange={(e) => setAction(e.target.value)}
                displayEmpty
                renderValue={(v) => v || 'Select action...'}
              >
                {EXCEPTION_ACTION_OPTIONS.map((opt) => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item md={4} xs={12}>
            <Typography variant="subtitle1" align="right">
              Remarks *
            </Typography>
          </Grid>
          <Grid item md={8} xs={12}>
            <TextField
              fullWidth
              name="remarks"
              label="Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              margin="dense"
              size="small"
              placeholder="Enter remark..."
              disabled={loading}
            />
          </Grid>
        </Grid>
      </form>
    </FormDialog>
  );
};

export default ExceptionHandlingDialog;

